module.exports = __webpack_public_path__ + "media/images/angle_down_old-613eb7c9eeef82c59a6ecb1480c69e54.png";